export const selectTicketsList = (state) => state.tickets.tickets;
